import { useComparedVariablesContext } from '../state/useComparedVariablesState'

export const useIsAcrossDatasetsComparison = () => {
  const { comparedVariables: [firstVariableData], comparedVariable } = useComparedVariablesContext()
  return firstVariableData?.acrossDatasets || comparedVariable?.acrossDatasets
}
